<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container">
        <div class="flex">
          <div class="left">
            <strong
              class="mt-0"
            >Articles for agencies helping clients to build an MVP of a SaaS idea</strong>
            <ul class="article-listing">
              <li v-for="(itm, itmIdx) in articleLinks" :key="itmIdx">
                <router-link :to="'/articles/' + itm.url">{{itm.url | urlToTitle}}</router-link>
              </li>
            </ul>
          </div>

          <div class="right">
            <router-view></router-view>
          </div>
        </div>
        <c-cta split />
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Secondary",
  components: {
    CGenericSection,
    CCta
  },
  filters: {
    urlToTitle: str => {
      return str.split("-").join(" ");
    }
  },
  data() {
    return {
      articleLinks: [
        {
          url:
            "glossary-of-vocabulary-that-agencies-should-know-when-discussing-web-apps-with-clients"
        }
      ]
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>

<style scoped>
ul.article-listing li {
  text-transform: capitalize;
}

.flex {
  display: flex;
}

.left {
  flex: 1;
}

.right {
  flex: 3;
}
</style>